import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// from https://stackoverflow.com/a/57530044/1188074
// addressed Angular issue described here: https://github.com/angular/angular/issues/19888
// where the type of HTTPErrorResponse.error is of type Blob instead of JSON
export class BlobErrorHttpInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (
          err instanceof HttpErrorResponse &&
          err.error instanceof Blob &&
          err.error.type === 'application/json'
        ) {
          // https://github.com/angular/angular/issues/19888
          // When request of type Blob, the error is also in Blob instead of object of the json data
          return new Promise<any>((_, reject) => {
            let reader = new FileReader();
            reader.onload = (evt: Event) => {
              try {
                const errObject = JSON.parse((<any>evt.target).result);
                reject(
                  new HttpErrorResponse({
                    error: errObject,
                    headers: err.headers,
                    status: err.status,
                    statusText: err.statusText,
                    url: err.url,
                  }),
                );
              } catch (_parseError) {
                reject(err);
              }
            };
            reader.onerror = (_readerError) => {
              reject(err);
            };
            reader.readAsText(err.error);
          });
        }
        return throwError(err);
      }),
    );
  }
}
